import gsap from 'gsap';
import EventDispatcher from './EventDispatcher';
import Global from './Global';
// import { gsap } from "gsap";

export default class Score {
  constructor() {
    document
      .querySelector('#backToHomeScore_btn')
      .addEventListener('mousedown', this.backToHome.bind(this));
    document
      .querySelector('#backToHomeScoreLooser_btn')
      .addEventListener('mousedown', this.backToHome.bind(this));
  }

  init() {
    this.events = EventDispatcher.getObj();
    this.events.addEventListener('LOADER_EVENTS', this.onEvents.bind(this));
    this.events.addEventListener('GAME_EVENTS', this.onEvents.bind(this));
    this.events.addEventListener('GAMESCENE_EVENTS', this.onEvents.bind(this));

    this.onProceed();
  }

  onEvents(data) {
    switch (data.message.event_type) {
      case 'show_screen':
        this.showScreen(data.message.data.screenKey);
        break;
    }
  }

  showScreen(screenKey) {
    if (screenKey != 'Score' && screenKey != 'Score_Fail') return false;

    if (screenKey === 'Score') {
      document.querySelector('#score_scr .content #score').innerHTML =
        Global.scoreTotal;

      document.querySelector('#score_scr .content .type').innerHTML =
        Global.language[`gameScoreInfo_${Global.collectableType}`][Global.lang];
      document.querySelector('#score_scr .content .dis').innerHTML =
        Global.language.draw[Global.lang];
      //
      this.pageAnimation('#score_scr');
      document.querySelector('#score_scr').classList.add('active');
    } else {
      document.querySelector('#scoreLooser_scr .content .header').innerHTML =
        Global.language.lostTitle[Global.lang];

      document.querySelector('#scoreLooser_scr .content .dis').innerHTML =
        Global.language[`lostTitle2_${Global.collectableType}`][Global.lang];

      this.pageAnimation('#scoreLooser_scr');
      document.querySelector('#scoreLooser_scr').classList.add('active');
    }
  }

  pageAnimation(parentID) {
    if (parentID === '#score_scr') {
      gsap.set('#backToHomeScore_btn', { opacity: 0 });
    } else {
      gsap.set('#backToHomeScoreLooser_btn', { opacity: 0 });
    }
    gsap.set(`${parentID} .content`, { opacity: 0 });

    gsap.fromTo(
      `${parentID} > .appContainer`,
      { scale: 0.2, opacity: 0 },
      { scale: 1, opacity: 1, duration: 1, ease: 'power3.out' }
    );

    setTimeout(() => {
      this.events.dispatchEvent({
        type: 'ANIMATION_EVENTS',
        message: {
          event_type: 'twistAnimation',
          data: {
            selector: `${parentID} .twistOnIt`,
          },
        },
      });

      setTimeout(() => {
        this.events.dispatchEvent({
          type: 'ANIMATION_EVENTS',
          message: {
            event_type: 'buttonAnimation',
            data: {
              selector:
                parentID === '#score_scr'
                  ? '#backToHomeScore_btn'
                  : '#backToHomeScoreLooser_btn',
            },
          },
        });
      }, 1000);
      gsap.to(`${parentID} .content`, {
        opacity: 1,
        duration: 1, // duration in seconds
        ease: 'power2.out', // optional easing
      });
    }, 500);
  }

  onProceed() {}

  backToHome() {
    if (Global.playerIndex == 2) {
      location.href = Global.baseURL;
    } else {
      Global.clickUpdater('backToHomeScore_btn');
      this.events.dispatchEvent({
        type: 'LOADER_EVENTS',
        message: {
          event_type: 'switch_page',
          data: {
            screenKey: 'Home',
          },
        },
      });
    }
  }
}
